<template>
    <f7-page class="page-shortcode">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>ĐẶT HỆ CÚ PHÁP</f7-nav-title>
            <f7-nav-right>
                <f7-link href="/cu-phap/tao-moi" icon-ios="f7:plus"></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <f7-block strong inset class="alert-notice text-bigger mt-1" v-if="announcements.length > 0">
            <span v-html="announcements[0].content"></span>
        </f7-block>
        <f7-block-title>DANH SÁCH</f7-block-title>
        <template v-if="!_.isEmpty(shortcodes)">
            <f7-list media-list>
                <f7-list-item
                    v-for="(item, idx) in shortcodes" :key="idx"
                    link="#"
                    @click.prevent="editShortcode(item)"
                    :title="item.shortcode"
                    :subtitle="item.result">
                </f7-list-item>
            </f7-list>
        </template>
        <f7-block strong class="text-align-center" v-else>CHƯA CÓ CÚ PHÁP NÀO</f7-block>
        <Footer/>
    </f7-page>
</template>
<style>
    .alert-notice img{
        max-width: 100%;
        margin: 10px auto;
    }
</style>
<script>
import Footer from "@/components/Footer";
import { mapState } from 'vuex';

export default {
    components: {
        Footer
    },
    data() {
        return {
            announcements: [],
        }
    },
    computed: {
        ...mapState(['shortcodes'])
    },
    methods: {
        editShortcode(shortcode) {
            this.$f7router.navigate('/cu-phap/chinh-sua', {
                props: {
                    id: shortcode.id,
                    shortcode: shortcode.shortcode,
                    result: shortcode.result
                }
            });
        },
        getAnnouncements() {
            this.$store.dispatch('getAnnouncements', {
                position: 'shortcode',
                limit: 1
            }).then((data) => {
                this.announcements = data;
            });
        },
    },
    mounted() {
        this.getAnnouncements();

        if (this._.isEmpty(this.shortcodes)) {
            this.$f7.dialog.preloader();

            this.$store.dispatch('getShortcodes').then(() => {
                this.$f7.dialog.close();
            }).catch((err) => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert(err, 'LỖI!');
            })
        }
    }
};
</script>
